/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Offline_ReadyInputs */

const es_pwa_offline_ready = /** @type {(inputs: Pwa_Offline_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La app está lista para funcionar sin conexión`)
};

const en_pwa_offline_ready = /** @type {(inputs: Pwa_Offline_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App ready to work offline`)
};

/**
* | output |
* | --- |
* | "App ready to work offline" |
*
* @param {Pwa_Offline_ReadyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const pwa_offline_ready = /** @type {((inputs?: Pwa_Offline_ReadyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Offline_ReadyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pwa_offline_ready(inputs)
	return en_pwa_offline_ready(inputs)
});
export { pwa_offline_ready as "pwa.offline_ready" }